import { ISpecificPagePromt, ITag } from "../../types";
import { TagActionsTypes } from "../actions/tagActions";

export const SET_IS_TAGS_LOADING_IN_PROGRESS =
  "tag/SET_IS_TAGS_LOADING_IN_PROGRESS";
export const SET_TAGS = "tag/SET_TAGS";
export const SET_TAG = "tag/SET_TAG";
export const SET_TOTAL_TAGS = "tag/SET_TOTAL_TAGS";
export const SET_IS_TAG_ADDING_IN_PROGRESS =
  "tag/SET_IS_TAG_ADDING_IN_PROGRESS";
export const SET_IS_TAG_UPDATE_IN_PROGRESS =
  "tag/SET_IS_TAG_UPDATE_IN_PROGRESS";
export const SET_ALL_TAGS = "tag/SET_ALL_TAGS";
export const SET_IS_LOADING_SPECIFIC_PAGE_PROMT_IN_PROGRESS =
  "tag/SET_IS_LOADING_SPECIFIC_PAGE_PROMT_IN_PROGRESS";
export const SET_IS_CREATING_SPECIFIC_PAGE_PROMT_IN_PROGRESS =
  "tag/SET_IS_CREATING_SPECIFIC_PAGE_PROMT_IN_PROGRESS";
export const SET_SPECIFIC_PAGE_PROMTS = "tag/SET_SPECIFIC_PAGE_PROMTS";
export const SET_IS_DELETING_SPECIFIC_PAGE_PROMT_IN_PROGRESS =
  "tag/SET_IS_DELETING_SPECIFIC_PAGE_PROMT_IN_PROGRESS";

const initialState = {
  isTagsLoadingInProgress: false,
  isTagAddingInProgress: false,
  tags: [] as ITag[],
  allTags: [] as ITag[],
  tag: null as null | ITag,
  totalTags: 0,
  isTagUpdateInProgress: false,
  isCreatingSpecificPagePromtInProgress: false,
  isLoadingfSpecificPagePromtInProgress: false,
  isDeletingSpecificPagePromtInProgress: false,
  specificPagePromts: [] as ISpecificPagePromt[],
};

type InitialStateType = typeof initialState;

export const tagReducer = (
  state = initialState,
  action: TagActionsTypes
): InitialStateType => {
  switch (action.type) {
    case SET_IS_TAGS_LOADING_IN_PROGRESS:
    case SET_IS_TAG_ADDING_IN_PROGRESS:
    case SET_TAGS:
    case SET_TAG:
    case SET_TOTAL_TAGS:
    case SET_IS_TAG_UPDATE_IN_PROGRESS:
    case SET_ALL_TAGS:
    case SET_IS_CREATING_SPECIFIC_PAGE_PROMT_IN_PROGRESS:
    case SET_IS_LOADING_SPECIFIC_PAGE_PROMT_IN_PROGRESS:
    case SET_IS_DELETING_SPECIFIC_PAGE_PROMT_IN_PROGRESS:
    case SET_SPECIFIC_PAGE_PROMTS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
